/**
 * Dependencies.
 */

import createResourceReducer from 'store/utils/createResourceReducer'
import { actionTypes } from 'store/actions/resources/opportunities'

/**
 * Opportunities reducer.
 */

export default createResourceReducer({ actionTypes })
